import { RefObject, useEffect } from "react";

type UseSidebarResizeParams = {
  isResizing: boolean;
  layoutRowRef: RefObject<HTMLDivElement | null>;
  setSidebarWidthPx: (value: number) => void;
  setIsResizing: (value: boolean) => void;
  min: number;
  max: number;
};

/** Desktop: drag the handle to set left sidebar width (px), relative to the main layout row. */
export function useSidebarResize({
  isResizing,
  layoutRowRef,
  setSidebarWidthPx,
  setIsResizing,
  min,
  max,
}: UseSidebarResizeParams): void {
  useEffect(() => {
    if (!isResizing) return;

    const onMove = (e: MouseEvent) => {
      const el = layoutRowRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const w = e.clientX - rect.left;
      setSidebarWidthPx(Math.min(max, Math.max(min, w)));
    };

    const onUp = () => setIsResizing(false);

    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseup", onUp);
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";

    return () => {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseup", onUp);
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };
  }, [isResizing, max, min, setSidebarWidthPx, setIsResizing, layoutRowRef]);
}
